import React from 'react';
import {Link} from 'react-router';
import {ShowIf} from 'components/utils';
import {checkServerLive} from 'constants/config';
import fileDownload from 'js-file-download';
import {downloadFile} from 'components/utils';

class RowItemChiTietDonViBCTH extends React.Component {

  render() {
    return (
      <tr>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='list-items-table'><Link className="txt-underline txt-regular" to={`/chi-tiet-bao-cao-tong-hop-cua-don-vi/${this.props.item.baoCaoDonViChiTietId}`}>{this.props.item.loaiBaoCaoInfo ? this.props.item.loaiBaoCaoInfo.ten : ''}</Link></td>
        <td>
          <ul className="list-items-table">
            {
              this.props.item.listTaiLieuBaoCao.map((item, index) => {
                if (!checkServerLive) {
                  return <li key={index}><Link className="txt-blue txt-underline" onClick={fileDownload.bind(this, item.urlFile, item.tenFile)}>{item.tenFile}</Link></li>
                }
                if (checkServerLive) {
                  return <li key={index}><Link className="txt-blue txt-underline" onClick={() => {downloadFile(item.urlFile, item.tenFile)}}>{item.tenFile}</Link></li>
                }
              })
            }
          </ul>
        </td>
      </tr>
    );
  }
}

export default RowItemChiTietDonViBCTH;



// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/datatable/RowItemChiTietDonViBCTH.jsx